import { environment } from '@/environments/environment';

/**
 * Resolve the ufs (cross-tenant SSO service) base URL.
 *
 * ufs is a per-environment service, NOT per-tenant — addressed as
 * `<env>.ufs.levvel.cloud` (prod has no env segment: `ufs.levvel.cloud`). It is
 * therefore never carried in the per-tenant runtime config (config.feature.
 * ufsEndpoint is deprecated); it's an env constant / host derivation instead.
 *
 * - `environment.ufsApiHost` set → use it (override). Only local.ts sets it, to
 *   pin the port-scoped `http://127.0.0.1:10000`. The legacy env files that used
 *   to reach this branch (each carrying its own cloud value, because their host
 *   naming wasn't uniform — dev vs develop) were deleted on 2026-09-06.
 * - otherwise → derive from the current host, replacing the tenant label (the
 *   segment just before `.levvel.cloud`) with `ufs`:
 *     develop.naestved.levvel.cloud → develop.ufs.levvel.cloud
 *     naestved.levvel.cloud (prod)  → ufs.levvel.cloud
 *
 * The derive branch never runs locally (override always wins), so it can only
 * be exercised on a deployed subdomain — covered by ufs.utils.test.ts.
 */
export function resolveUfsHost(): string {
  if (environment.ufsApiHost) return environment.ufsApiHost;
  const { protocol, host } = window.location;
  const derived = host.replace(/[^.]+(\.levvel\.cloud)$/, 'ufs$1');
  return `${protocol}//${derived}`;
}
